import { render, staticRenderFns } from "./SimpleArithmetic.vue?vue&type=template&id=6beff292&"
import script from "./SimpleArithmetic.vue?vue&type=script&lang=js&"
export * from "./SimpleArithmetic.vue?vue&type=script&lang=js&"
import style0 from "./SimpleArithmetic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports